import { render, staticRenderFns } from "./ButtonLinkSecondary.vue?vue&type=template&id=002d2ba1&scoped=true"
import script from "./ButtonLinkSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonLinkSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d2ba1",
  null
  
)

export default component.exports